module.exports = "<div>\n    <h3>{{ $ctrl.stateTitle }}</h3>\n\n    <ng-transclude></ng-transclude>\n</div>\n\n<span flex></span>\n";